export const TIPO_OCORRENCIA_PGTO = [
    {
        id: 'UNICA',
        descricao: "Única",
    },
    {
        id: 'PARCELADA',
        descricao: "Parcelada",
    },
];